define.alias("shared/components/shared/social/tiktok-details", "settings/components/shared/social/tiktok-details");